<template>
  <!-- 景區資訊 事件總覽 -->
  <div class="col">
    <!-- <emergencyEvent></emergencyEvent> -->
    <div class="card card-clean h-100">
      <div class="card-header bg-white border-0 fw-bold text-indigo h5">
        事件總覽
      </div>
      <div class="card-body px-2 py-1">
        <div class="tabbed">
          <input
            type="radio"
            :id="'tab' + i + 'b'"
            name="css-tabs3"
            v-for="(emergencyEvent, i) in testList"
            :key="i + 'a'"
            @change="selectedEvent = emergencyEvent.id"
            :checked="i === 0"
          />
          <ul class="nav nav-tabs nav-tabs-custom faq-tab-box tabs sm-wrap">
            <li
              class="tab px-0 nav-item flex-fill"
              v-for="(emergencyEvent, i) in testList"
              :key="i + 'm'"
            >
              <label
                class="nav-link py-1 text-center h-100"
                :for="'tab' + i + 'b'"
                :class="setEventLabelClass(emergencyEvent.description)"
                >{{ emergencyEvent.description }}</label
              >
            </li>
          </ul>
          <div
            class="tab-content event-area"
            v-for="(emergencyEvent, i) in testList"
            :key="i"
          >
            <h1 class="text-center text-primary-emphasis" v-if="!eventList">
              目前尚無事件
            </h1>
            <div class="z-depth-1-half" v-if="eventList">
              <table class="table shadow-sm" id="eventTable">
                <thead class="table-dark">
                  <tr>
                    <th
                      class=""
                      v-for="(col, i) in emergencyEvent.column"
                      :key="i"
                    >
                      {{ col }} <button @click="toggleSortTime" class="sort-btn" v-if="i === (emergencyEvent.column.length - 2)"> 
                        <i :class="isAscending ? 'fas fa-chevron-up' : 'fas fa-chevron-down'"></i>
                      </button>
                    </th>
                  </tr>
                </thead>
                <tbody class="table-group-divider">
                  <tr v-for="(event, i) in eventList" :key="i">
                    <td>{{ event.ScenicAreaName }}</td>
                    <td v-if="selectedEvent === 0">{{ event.eventType }}</td>
                    <td>{{ getTime(event.eventTime) }}</td>
                    <td>{{ event.dismissContent }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import VueApexCharts from "vue-apexcharts";
import CONST from "../../utils/const";
import Utils from "../../utils/utils";
import { mapState, mapGetters } from "vuex";
import violation from "../../store/modules/adminDist/violation";

export default {
  components: {},
  props: {
    selectedScenicAreaId: {
      type: Number,
      // required: true,
    },
  },
  data() {
    return {
      selectedEvent: 0,
      // nowDate : moment().startOf("day").format("YYYY-MM-DD"),
      // nowDate : "2022-10-26",

      eventType: [],
      testList: [], //篩選過後顯示的事件種類

      eventList: [],
      propEventList: [], //集合所有事件 (判斷頁籤變色用)
      eventArray: [], //所有事件的事件種類
      emergencyEvents: [],
      emergencyEventData: [],

      disasters: [],
      controlHistory: [],
      controlHistoryData: [],
      violation: [],
      violationData: [],
      parkingLimit: [],
      parkingLimitData: [],
      deviceError: [],
      deviceErrorData: [],
      iotEvent: [],
      iotEventData: [],
      isAscending: true,
    };
  },
  methods: {
    getTime: function (time) {
      if (Utils.isEmptyObject(time)) {
        return "-";
      }
      return moment(time).format("YYYY/MM/DD HH:mm");
    },

    getDeviceTypeName: function (deviceType) {
      const deviceTypeName = CONST.EAST_COAST_DEVICE_TYPE_ENUM[deviceType];
      if (deviceTypeName) {
        return `${deviceTypeName}`;
      } else {
        return "UnknownType";
      }
    },
    //根據景區選擇顯示事件分類
    async getFilterList() {
      console.log()
      const additionInfo = await this.myScenicAreaList.find(
        (item) => item.id === this.selectedScenicAreaId
      )?.additionInfo;
      this.testList = [
        CONST.SCENIC_AREA_EVENT_INFO[0], //全部
        CONST.SCENIC_AREA_EVENT_INFO[7], // 設備異常
      ];

      if (additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.SOS) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[1]); // 緊急求救
      }
      if (additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CAR_FLOW) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[2]); // 容留上限
      }

      if (additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.VIOLATION) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[3]); //違規
      }
      if (additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.WEATHER_INFO) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[4]); //警特報災情
      }

      if (
        additionInfo &
        CONST.SCENIC_AREA_ADDITION_INFO_ENUM.PROVIDER_TOILET_DEVICE
      ) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[5]); //公廁維護
      }

      if (
        additionInfo & CONST.SCENIC_AREA_ADDITION_INFO_ENUM.CLOSE_IN_ADVANCE
      ) {
        this.testList.push(CONST.SCENIC_AREA_EVENT_INFO[6]); //管制
      }

      //事件排序按照 SCENIC_AREA_EVENT_INFO.id
      this.testList = this.testList.sort((a, b) => a.id - b.id);
    },

    //根據景區篩選該區事件
    async setEventData(sc) {
      console.log("進setEventData",sc)
      const a = this.emergencyEventData.map((emergencyEvent) => ({
        ...emergencyEvent,
        eventType: "緊急求救",
      }));

      const b = this.disasterList.map((disaster) => ({
        ...disaster,
        eventType: "天氣風險",
      }));

      const c = this.controlHistoryData.map((controlHistory) => ({
        ...controlHistory,
        eventType: "管制",
      }));

      const v = this.violationData.map((violation) => ({
        ...violation,
        eventType: "違規",
      }));

      const p = this.parkingLimitData.map((parkingLimit) => ({
        ...parkingLimit,
        eventType: "容留上限",
      }));

      const d = this.deviceErrorData.map((deviceError) => ({
        ...deviceError,
        eventType: "設備",
      }));

      const t = this.iotEventData.map((iotEvent) => ({
        ...iotEvent,
        eventType: "公廁維運",
      }));


      //篩選值 = selectedScenicAreaId 的 data
      this.emergencyEvents = a.filter((item) => item.scenicAreaId === sc);
      this.disasters = b.filter((item) => item.scenicAreaId === sc);
      this.controlHistory = c.filter((item) => item.scenicAreaId === sc);
      this.violation = v.filter((item) => item.scenicAreaId == sc ) // 違規只能選單一景區 無法查全部

      this.parkingLimit = p.filter((item) => item.scenicAreaId === sc);
      this.deviceError = d.filter((item) => item.scenicAreaId === sc);
      this.iotEvent = t.filter((item) => item.scenicAreaId === sc);
    },

    //根據選擇事件顯示事件資訊
    async setEventType() {
      this.eventList = [];
      switch (this.selectedEvent) {
        default: //全部
          this.eventList = this.emergencyEvents
            .concat(this.disasters)
            .concat(this.controlHistory)
            .concat(this.violation)
            .concat(this.parkingLimit)
            .concat(this.deviceError)
            .concat(this.iotEvent);
          if (Object.keys(this.eventList).length > 0) {
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;
        case 0: //全部
          this.eventList = this.emergencyEvents
            .concat(this.disasters)
            .concat(this.controlHistory)
            .concat(this.violation)
            .concat(this.parkingLimit)
            .concat(this.deviceError)
            .concat(this.iotEvent);
          if (Object.keys(this.eventList).length > 0) {
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 1: //緊急求救
          if (Object.keys(this.emergencyEvents).length > 0) {
            this.eventList = this.emergencyEvents;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 2: //容留上限
          if (Object.keys(this.parkingLimit).length > 0) {
            this.eventList = this.parkingLimit;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 3: //違規
          if (Object.keys(this.violation).length > 0) {
            this.eventList = this.violation;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 4: //警特報災情
          if (Object.keys(this.disasters).length > 0) {
            this.eventList = this.disasters;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 5: //公廁維護
          if (Object.keys(this.iotEvent).length > 0) {
            this.eventList = this.iotEvent;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 6: //管制
          if (Object.keys(this.controlHistory).length > 0) {
            this.eventList = this.controlHistory;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;

        case 7: //設備異常
          if (Object.keys(this.deviceError).length > 0) {
            this.eventList = this.deviceError;
            Utils.setEventDataTimeDesc(this.eventList);
          } else {
            this.eventList = false;
          }
          this.getPropEventList();

          break;
      }

    },

    async getPropEventList() {
      this.propEventList = this.emergencyEvents
        .concat(this.disasters)
        .concat(this.controlHistory)
        .concat(this.violation)
        .concat(this.parkingLimit)
        .concat(this.deviceError)
        .concat(this.iotEvent);

      // console.log("propEventList",this.propEventList)
      this.getEventLabelClass();
    },

    async getEventLabelClass() {
      this.eventArray = [
        ...new Set(this.propEventList.map((item) => item.eventType)),
      ]; //取得不重複ScenicAreaName重組陣列
      if (this.eventArray.length > 0) {
        this.eventArray.push("全部");
 
      }
    },

    setEventLabelClass(item) {
      if (this.eventArray.includes(item)) {
        return "bg-danger";
      }
    },

    toggleSortTime() {
      this.isAscending = !this.isAscending;
      // console.log("event",this.eventList)

      this.sortData();
    },

    sortData() {
      if (this.isAscending) {
        Utils.setEventDataTimeAsc(this.eventList);
      } else {
        Utils.setEventDataTimeDesc(this.eventList);
      }
    },
    getCarType(type){
      switch (type) {
        case "compact":
          return "小型車";
        case "fullSize":
          return "大型車(大型巴士)";
        case "smallBus":
          return "大型車(小型巴士)";
        case "truck":
          return "大型車(卡車)";
        case "motorcycle":
          return "機車";
      }
    },

  },
  computed: {
    ...mapGetters("scenicArea", { myScenicAreaList: "getMyScenicArea" }),
    ...mapGetters("emergencyEvent", { emergencyEventList: "getEvents" }),
    ...mapGetters("disasterMonitor", { disasterList: "getAllDisaster" }),
    ...mapState("controlHistory", {
      controlHistoryList: "controlHistoryByTimeInterval",
    }),
    ...mapGetters("violation", { violationList: "getViolationData" }),
    ...mapGetters("iotEvent", { iotEventList: "getIotEventData" }),
    ...mapGetters("parkingAvailabilityRate", {
      parkingLimitList: "getAllParkingAvailabilityRate",
    }),
    ...mapState("deviceError", { deviceErrorList: "deviceDailyErrorList" }),
  },
  watch: {
    myScenicAreaList: {
      handler() {},
      // immediate: true,
    },

    selectedScenicAreaId: {
      async handler(newVal) {
        if(newVal === null )return;
        
        console.log("newVal >0", newVal);
        await this.setEventData(newVal); //根據景區篩選該區事件
        await this.getFilterList(); //景區事件頁籤
        this.setEventType();//根據選擇事件顯示事件資訊
       
      },
      immediate: true,
    },

    selectedEvent: {
      handler() {
        this.setEventType();
      },
    },

    emergencyEventList: {
      handler(newVal) {
        this.emergencyEventData = newVal.map((e) => {
          const emergencyEvent = {};
          emergencyEvent.scenicAreaId = e.scenicAreaId;
          emergencyEvent.ScenicAreaName = `${e.scenicAreaName} ─ ${e.placeName}`;
          emergencyEvent.scenicAreaName = e.scenicAreaName;
          emergencyEvent.eventTime = e.eventTime;
          emergencyEvent.dismissContent = e.dismissContent;
          emergencyEvent.eventType = "緊急求救";
          return emergencyEvent;
        });
        Utils.setScenicAreaNamebyId();
      },
    },

    disasterList: {
      handler(newVal) {
        Utils.setScenicAreaNamebyId(newVal);
        Utils.setDisasterContent(newVal);
        // this.setEventData(this.selectedScenicAreaId);
        this.setEventType();
      },
    },

    controlHistoryList: {
      handler(newVal) {
        this.controlHistoryData = newVal.map((e) => {
          const controlHistory = {};
          controlHistory.scenicAreaId = e.scenicAreaId;
          controlHistory.ScenicAreaName = e.scenicAreaName;
          controlHistory.eventTime = e.controlStartTime;
          controlHistory.dismissContent = "啟動管制";

          return controlHistory;
        });

        this.setEventData(this.selectedScenicAreaId);
        this.setEventType();
      },
    },
    violationList: {
      handler(newVal) {
        this.violationData = newVal.map((e) => {
          const violation = {};
          violation.scenicAreaId = e.areaId;
          violation.ScenicAreaName = `${e.areaName} ─ ${e.publicPlaceName}`;
          violation.eventTime = e.dt;
          violation.dismissContent = Utils.getViolationType(e.violationType);

          return violation;
        });

        this.setEventData(this.selectedScenicAreaId);
        this.setEventType();
      },
    },

    parkingLimitList: {
      handler(newVal) {
        this.parkingLimitData = newVal.map((e) => {
          const parkingLimit = {};
          parkingLimit.scenicAreaId = e.scenicAreaId;
          parkingLimit.ScenicAreaName = e.scenicAreaName;
          parkingLimit.eventTime = e.startTime;
          // parkingLimit.dismissContent =
          // (e.warningLevel === "yellow" ? "警戒 - 已達八成" : "警戒 - 已達九成")+` (${this.getCarType(e.passengerType)})`;
            parkingLimit.dismissContent =
            (e.warningLevel === "yellow" ? "警戒 - 已達八成" : "警戒 - 已達九成");
         
          return parkingLimit;
        });
        // this.setEventData(this.selectedScenicAreaId);
        this.setEventType();
      },
    },

    deviceErrorList: {
      handler(newVal) {
        this.deviceErrorData = newVal.map((e) => {
          const deviceError = {};
          deviceError.scenicAreaId = e.areaId;
          deviceError.ScenicAreaName = `${e.scenicAreaName} ─ ${e.publicPlaceName}`;
          deviceError.eventTime = e.happenTime;
          deviceError.dismissContent = `${
            e.deviceErrorType
          } ─ ${this.getDeviceTypeName(e.deviceType)}`;

          return deviceError;
        });

        // this.setEventData(this.selectedScenicAreaId);
        this.setEventType();
      },
    },

    iotEventList: {
      handler(newVal) {
        Utils.setScenicAreaNamebyId(newVal);

        const target = newVal.filter(
          (item) => item.eventType === "nilometer" || item.eventType === "odor"
        );
        this.iotEventData = target.map((e) => {
          const iotEvent = {};
          iotEvent.scenicAreaId = e.scenicAreaId;
          iotEvent.ScenicAreaName = `${e.ScenicAreaName}`;
          iotEvent.eventTime = e.eventTime;
          iotEvent.dismissContent = `${e.publicPlaceName} ${e.eventTypeName}-${e.infoPriority}`;

          return iotEvent;
        });

      
        this.setEventType();
      },
    },


  },

  getparkingLimitStatus(status) {
    switch (status) {
      case "green":
        return "尚未警戒";

      case "yellow":
        return "警戒 - 已達八成";

      case "red":
        return "警戒 - 已達九成";
    }
  },

  async mounted() {
    setTimeout(() => {
      this.setEventData(this.selectedScenicAreaId);
      this.setEventType();
    }, 1000);
    
  },
};
</script>

<style lang="scss" scoped>
$max: 20;
@for $i from 1 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label {
    background: #00ae9a !important;
    color: #fff;
  }

  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tabs
    .tab:nth-of-type(#{$i})
    label:after {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@for $i from 1 through $max {
  .tabbed
    [type="radio"]:nth-of-type(#{$i}):checked
    ~ .tab-content:nth-of-type(#{$i}) {
    display: block;
    box-shadow: none;
  }
}

.nav-tabs li .nav-link:hover {
  background-color: #00ae9a;
  color: #fff;
  border-bottom: 0.8px solid #eee;
  border-top: 0.8px solid #eee;

  // border:1px !important;
}
.table th {
  position: sticky;
  top: 0;
}

.event-area {
  height: 16rem;
  min-height: 16rem;
  max-height: 16rem;

  overflow-y: scroll;
  overflow-x: scroll;
}

.sort-btn{
  border: none;
  background: none;
  color:white;
  padding: 0 0 0 5px;
  // background-color: none;
}

.sort-btn i {
  font-size: 10px;
}

.card-body .tabbed .sm-wrap{
      // min-width: 290px;

    @media (max-width: 350px) {
        flex-wrap: wrap;
      }
    @media (min-width: 351px) {
        flex-wrap: nowrap;
      }

  }
</style>
